import * as React from 'react';
import {Box} from '@mui/material';
import {ChartContainer} from '../../Common/ChartContainer';
import {configSchema} from './configSchema';
import {ISubmissionProps} from '../../resources/submission';

interface IVolunteerActivationProps {
    submissions: ISubmissionProps[]
}

const RateOfReachingExpected = ({submissions}: IVolunteerActivationProps) => {
    return (
        <Box>
            <ChartContainer
                configSchema={configSchema({submissions})}
                usePercentage={true}
                legendEnabled={false}
            />
        </Box>
    )
}

export default RateOfReachingExpected;